import type { TwoFactorType } from "../tastyworks"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class DeviceChallenge {
  step = ""
  question = ""
  device = ""
  email = ""
  location = ""
  phone = ""
  twoFactorType?: TwoFactorType | undefined
}

export const DEVICE_CHALLENGE_DESER: SchemaDeSer<DeviceChallenge> =
  new SchemaDeSerBuilder(DeviceChallenge)
    .ofString("email")
    .ofString("device")
    .ofString("location")
    .ofString("question")
    .ofString("phone")
    .ofString("step")
    .toDeSer()
